module.exports = __webpack_public_path__ + "static/dhd-favicon-57-7dfdd9dde25ecf6f376a97e21f4e3aa4.png";